import { render } from "./UploadIcon.vue?vue&type=template&id=952c29d2"
const script = {}
script.render = render

export default script